import { FSLocale, localeLink } from '@fshr/shared';
import Button from '../button';
import { ChevronBoldLeft } from '../icon/chevron-bold-left';
import Link from '../link';
import { useTranslations } from '@fshr/context/i18n-context';

type ReturnAllStaysSectionProps = {
	closeComponent?: () => void;
	redirect: boolean;
	locale?: string;
};

export function ReturnAllStaysSection(props: ReturnAllStaysSectionProps) {
	const { closeComponent, redirect, locale = 'en' } = props;
	const t = useTranslations();

	const handleAllStaysButtonClick = () => {
		if (closeComponent) {
			closeComponent();
		}
	};

	return (
		<div
			role="navigation"
			aria-label={t('Return to all stays')}
			className="text-button2 flex flex-row items-center pt-[20px] pr-[15px] pb-[10px] pl-[10px] md:pt-300 md:pr-200 md:pl-150 md:pb-150"
		>
			{!redirect ? (
				<Button
					hasIcon
					intent="unstyled"
					className="cursor-pointer text-button2"
					onClick={handleAllStaysButtonClick}
					aria-label={t('Return to all stays')}
					tabIndex={0}
				>
					<div className="w-full flex flex-row spacing-button-inline-icon">
						<ChevronBoldLeft />
						<p role="navigation" className="text-text-secondary">
							{t('All Stays')}
						</p>
					</div>
				</Button>
			) : (
				<Link
					href={localeLink(locale as FSLocale)('/profile/my-stays')}
					className="cursor-pointer text-button2"
					aria-label={t('Return to all stays')}
					intent="unstyled"
				>
					{
						<div className="w-full flex flex-row spacing-button-inline-icon">
							<ChevronBoldLeft />
							<p role="navigation" className="text-text-secondary">
								{t('All Stays')}
							</p>
						</div>
					}
				</Link>
			)}
		</div>
	);
}
